import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Switch, Typography } from '@lyearn/ui';
import NumberInput from '@/components/NumberInput';

import { TextCharacterLimitProps } from './types';

function TextCharacterLimit(props: TextCharacterLimitProps) {
  const { value, onChange } = props;
  const { t } = useTranslation();

  const onToggleCharacterLimit = useCallback(
    (_event: any, checked: boolean) => {
      onChange(checked ? Number.NaN : null);
    },
    [onChange],
  );

  const showInput = typeof value === 'number';

  return (
    <Stack direction="col" gapY={20}>
      <Stack alignItems="center" justifyContent="between">
        <Typography className="ms-8" color="text-text-primary" variant="body-short-02">
          {t('Database:MaxCharacters')}
        </Typography>
        <Switch checked={showInput} onChange={onToggleCharacterLimit} />
      </Stack>
      {showInput ? (
        <NumberInput
          canBeEmpty
          className="w-full"
          min={0}
          placeholder={t('Database:MaxCharactersPlaceholder')}
          size="medium"
          value={value}
          onChange={onChange}
        />
      ) : null}
    </Stack>
  );
}

export default TextCharacterLimit;
